module.exports = __webpack_public_path__ + "static/media/plates-logo.96535564.svg";